import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './HavenNav.css'

import { connect } from 'react-redux'
import { showSideMenu } from '../../../../Actions/MyHavenSideMenuAction'
import { hideSideMenu } from '../../../../Actions/MyHavenSideMenuAction'
import { showReferrals } from '../../../../Actions/showReferralsAction'
import AddReferrals from '../HavenReferrals/AddReferrals/AddReferrals';
import SideMenu from '../SideMenu/SideMenu';
import {logout} from '../../../../Actions/authAction'
import Notification from '../../../Notifications/Notifications';


class HavenNav extends Component {
    state={
        form_heading: "",
        show_added_notification: 'none'
    }
 

    componentWillUnmount() {
        //when the component unmounts hide the side menu 
        this.props.clickHide();
    }

    referralAdded = () => {
        console.log("referral added");
    this.setState({
        form_heading: "Referral Submitted!",
        show_added_notification: 'block'
    })
    setTimeout(() => {
        document.getElementById("formHeading").style.color = "#000000";
        this.setState({
            form_heading: "",
            show_added_notification: 'none' 
        })
    }, 8000)
    
    }
  
    render() { 
        return ( 

            <div>
                <div className="container-fluid background-blue">
                <div className="container">
                    <nav className="navbar navbar-expand-lg navbar-haven">
                        <NavLink className="navbar-brand myhaven-brand" to="/dashboard">
                        {
                            this.props.role === "Customer" ? "MyHaven" : "Westhaven Referrals"
                        }         
                        </NavLink>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"><i className="fas fa-bars"></i></span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarText">
                        {
                            this.props.role === "Customer" ? 
                            <ul className="navbar-nav mr-auto">
                                <li className="nav-item ">
                                    <Link to ="/dashboard" className="nav-link links" >Dashboard</Link>
                                </li>
                                <li className="nav-item ">
                                <Link to ="/dashboard/referrals" className="nav-link links" >Referrals</Link>
                                </li>
                                <li className="nav-item ">
                                <Link to ="/faq" className="nav-link links" >Faq</Link>
                                </li>
                            </ul>
                            : <ul className="navbar-nav mr-auto">
                                </ul>
                        }
                        {

                        //<button id="logout-btn" className="btn btn-primary addReferralsBtn" onClick={this.props.showReferrals}> <i className="fas fa-user-plus"></i> Contact Us</button>
                        }
                        <button id="logout-btn" className="btn btn-primary addReferralsBtn" onClick={this.props.showReferrals}> <i className="fas fa-user-plus"></i> Add A Referral</button>
                        <div className="dropdown">
                
                            <button className="nav-link nameBox" id="welcome-text" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Hi, {this.props.firstname} <i className="fas fa-angle-down"></i></button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <SideMenu />
                            </div>
                        </div>
                        
                        </div>
                    </nav>
                </div>
            </div>
            <AddReferrals referralAdded={this.referralAdded} />
            
            <Notification show_added_notification={this.state.show_added_notification} form_heading={this.state.form_heading}/>
        </div>
         )
    }
}

const mapStateToProps = state => ({
    showSideMenuProp: state.showMenu.showMenu,
    firstname: state.firebase.firstName,
    email: state.firebase.email,
    role: state.firebase.role
})

const mapDispatchToProps = (dispatch) => {
    return {
        clickShow: () => dispatch(showSideMenu("SHOW_MENU")),
        clickHide: () => dispatch(hideSideMenu("HIDE_MENU")),
        showReferrals: () => dispatch(showReferrals("")),
        logout: () => dispatch(logout())
        
  }
}
export default connect(mapStateToProps, mapDispatchToProps) (HavenNav);




// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/HavenNav/HavenNav.jsx